import * as React from "react";
const SvgFiRrCalendarHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-calendar-heart_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-1V1a1 1 0 0 0-2 0v1H8V1a1 1 0 0 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5M5 4h14c1.654 0 3 1.346 3 3v1H2V7c0-1.654 1.346-3 3-3m14 18H5c-1.654 0-3-1.346-3-3v-9h20v9c0 1.654-1.346 3-3 3m-5.108-10.115a2.84 2.84 0 0 0-1.969.807 2.84 2.84 0 0 0-1.969-.807c-1.637 0-2.969 1.436-2.969 3.2 0 1.578 1.208 3.33 3.695 5.358.36.293.801.44 1.242.439.441 0 .883-.146 1.243-.44 2.486-2.028 3.694-3.781 3.694-5.357 0-1.764-1.332-3.2-2.969-3.2zm-1.947 7.007c-2.67-2.178-2.959-3.388-2.959-3.808 0-.662.435-1.2.969-1.2s.969.538.969 1.2a1 1 0 0 0 2 0c0-.662.435-1.2.969-1.2s.969.538.969 1.2c0 .419-.288 1.629-2.916 3.808z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-calendar-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCalendarHeart;
